import { render } from "./moudle2.vue?vue&type=template&id=6392b7e6&ts=true"
import script from "./moudle2.vue?vue&type=script&lang=ts"
export * from "./moudle2.vue?vue&type=script&lang=ts"

import "./moudle2.vue?vue&type=style&index=0&id=6392b7e6&lang=scss&scope=true"

import exportComponent from "/Users/haoxunming/Desktop/flowbox公司项目/flowbox/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__